import { PayloadAction } from '@reduxjs/toolkit';
import { FontPack } from '@/types/theme-packs.types';
import { TemplatesReducerCreator } from '../types';

const appendFontPacksReducer = (create: TemplatesReducerCreator) => {
  return create.reducer((state, action: PayloadAction<FontPack>) => {
    const existingFontPack = state.fontPacks?.find((pack) => pack.font_pack === action.payload.font_pack);

    //if a match was found when creating a font pack, do not re add to the store
    if (existingFontPack) return;

    state.fontPacks = [...(state.fontPacks || []), action.payload];
  });
};

export default appendFontPacksReducer;
